import { z } from "zod";

export const DeviceSchema = z.object({
  device_index: z.string().optional(),
  device_id: z.string().trim().min(1, "Device ID(MAC ID) is required"),
  device_name: z.string().optional(),
  connection_protocol: z
    .string()
    .refine((val) => ["SSH", "R Login"].includes(val), {
      message: "Connection Protocal is required",
    }),
  ip_address: z.string().trim().min(1, "IP Address is required"),
  device_username: z.string().optional(),
  device_password: z.string().optional(),
  device_os_type: z
    .string()
    .refine((val) => ["Windows", "Linux"].includes(val), {
      message: "Device Os Type requied",
    }),
  device_cpu_type: z
    .string()
    .refine((val) => ["x86", "AMD", "Power PC"].includes(val), {
      message: "CPU Type required",
    }),
  sensor_agent_version: z
    .string()
    .trim()
    .min(1, "Sensor Agent Version is required"),
  sensor_agent_type: z
    .string()
    .refine((val) => ["Agent", "Host"].includes(val), {
      message: "Sensor Agent Type required",
    }),
  status: z.enum(["active", "inactive"]).optional(),
  created_at: z.string().optional(),
});

export type Device = z.infer<typeof DeviceSchema>;
